export default "<h1>Type8Timestamp list</h1>\n<spec-app-type8-timestamp-table [clickHandler]=\"createClickHandler()\"></spec-app-type8-timestamp-table>";